<template>
  <div>
    <!-- 参数错误页面 -->
    <div class="error-container" v-if="showError">
      <div class="error-wrapper">
        <div class="error-icon">
          <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
            <circle
              cx="30"
              cy="30"
              r="28"
              stroke="#ff6b6b"
              stroke-width="3"
              fill="none"
            />
            <path
              d="M30 18 L30 32"
              stroke="#ff6b6b"
              stroke-width="3"
              stroke-linecap="round"
            />
            <circle cx="30" cy="40" r="1.5" fill="#ff6b6b" />
          </svg>
        </div>
        <div class="error-message">{{ errorMessage }}</div>
        <div class="error-button" @click="goBack">返回</div>
      </div>
    </div>

    <div class="htmlStyle" v-html="htmlData" v-if="!showError"></div>

    <!-- 加载动画 -->
    <div
      class="loading-container"
      :class="{ 'fade-out': !showLoading }"
      v-if="(showLoading || isFadingOutLoading) && !showError"
    >
      <div class="loading-wrapper">
        <div class="loading-dots">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <div class="loading-text">加载中...</div>
      </div>
    </div>

    <!-- 进度条容器 -->
    <div
      class="progress-container"
      :class="{ 'fade-out': !showProgress }"
      v-if="(showProgress || isFadingOut) && !showError"
    >
      <div class="progress-wrapper">
        <div class="progress-circle">
          <svg class="progress-svg" viewBox="0 0 100 100">
            <circle
              class="progress-bg"
              cx="50"
              cy="50"
              r="45"
              fill="none"
              stroke="#e0e0e0"
              stroke-width="8"
            />
            <circle
              class="progress-bar"
              cx="50"
              cy="50"
              r="45"
              fill="none"
              stroke="url(#gradient)"
              stroke-width="8"
              stroke-linecap="round"
              :stroke-dasharray="circumference"
              :stroke-dashoffset="dashOffset"
              transform="rotate(-90 50 50)"
            />
            <defs>
              <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stop-color="#3776ff" />
                <stop offset="100%" stop-color="#1b5dd9" />
              </linearGradient>
            </defs>
          </svg>
          <div class="progress-text">
            <div class="progress-percentage">{{ progress }}%</div>
          </div>
        </div>
        <div class="progress-message">
          <div class="message-icon">💡</div>
          <div class="message-text">{{ currentMessage }}</div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="reportInterpre-foot" v-show="htmlData">
      <span @click="toPage('enterpriseServices')">更多产品</span>
      <span
        :class="{ 'btn-disabled': !expertBtnConfig.path }"
        @click="expertBtnConfig.path && toPage(expertBtnConfig.path)"
      >{{ expertBtnConfig.text }}</span>
    </div>
  </div>
</template>

<script>
import { companyRepoAnalyze, companyRepoAnalyzeGet } from "@/api/companyRep";
import { Toast } from "vant";
import { getWx } from "@/utils/wxJsSdk.js";
import { REPORT_EXPERT_BTN_CONFIG } from "@/config/platform.js";
import { getDepNameByDomain } from "@/utils/index";
export default {
  data() {
    return {
      reportId: "",
      htmlData: "",
      showProgress: false,
      progress: 0,
      remainingTime: 70,
      circumference: 283,
      timer: null,
      pollingTimer: null,
      currentMessage: "正在分析企业数据...",
      hasShown80sMessage: false,
      useServerProgress: false,
      isFadingOut: false,
      showLoading: false,
      isFadingOutLoading: false,
      showError: false,
      errorMessage: "缺少必要的报告ID参数",
      进度阶段语句: {
        20: "正在准备数据...",
        40: "正在评估企业信用状况...",
        60: "正在生成深度分析报告...",
        80: "即将完成，请稍候...",
      },
      channelId: this.$route.query.channelId,
    };
  },
  computed: {
    dashOffset() {
      return this.circumference - (this.progress / 100) * this.circumference;
    },
    expertBtnConfig() {
      const depName = getDepNameByDomain();
      return REPORT_EXPERT_BTN_CONFIG[depName] || { text: '等待配置', path: '' };
    },
  },
  mounted() {
    this.getQuery();
    // 获取分享内容模板
    this.getShareTxt();
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    toPage(name) {
      this.$router.push({
        path: "/" + name,
        query: { channelId: this.channelId },
      });
    },
    startProgressTimer() {
      this.showProgress = true;
      this.progress = 0;
      this.remainingTime = 70;
      this.currentMessage = "正在分析企业数据...";
      this.useServerProgress = false;

      this.timer = setInterval(() => {
        this.remainingTime--;

        if (!this.useServerProgress && this.remainingTime > 0) {
          this.progress = Math.round(((70 - this.remainingTime) / 70) * 100);

          if (this.进度阶段语句[this.progress]) {
            this.currentMessage = this.进度阶段语句[this.progress];
          }
        } else if (!this.useServerProgress) {
          this.progress = 99;

          if (this.remainingTime <= -10 && !this.hasShown80sMessage) {
            this.currentMessage = "数据量比较大，请耐心等候...";
            this.hasShown80sMessage = true;
          } else if (!this.hasShown80sMessage) {
            this.currentMessage = "正在生成最终报告...";
          }
        }

        companyRepoAnalyzeGet(this.reportId)
          .then((res) => {
            if (res.status === "1") {
              if (res.useTime) {
                this.useServerProgress = true;
                this.progress = Math.round((res.useTime / 70) * 100);
                if (this.progress > 99) {
                  this.progress = 99;
                }
                if (this.进度阶段语句[this.progress]) {
                  this.currentMessage = this.进度阶段语句[this.progress];
                }
              }
            } else if (res.status === "2") {
              this.clearTimer();
              this.currentMessage = "分析完成！";
              this.htmlData = res.body;
              this.smoothComplete();
            }
          })
          .catch(() => {
            this.clearTimer();
            this.showProgress = false;
            this.isFadingOut = true;
            setTimeout(() => {
              this.showError = true;
              this.errorMessage = "网络错误，请联系管理员";
              this.isFadingOut = false;
            }, 800);
          });
      }, 1000);
    },
    smoothComplete() {
      let currentProgress = this.progress;
      const targetProgress = 100;
      const interval = 20;
      const step = (targetProgress - currentProgress) / 5;

      const smoothTimer = setInterval(() => {
        currentProgress += step;
        if (currentProgress >= targetProgress) {
          currentProgress = targetProgress;
          clearInterval(smoothTimer);
          this.progress = currentProgress;

          setTimeout(() => {
            this.showProgress = false;
          }, 800);
        } else {
          this.progress = Math.round(currentProgress);
        }
      }, interval);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
    getQuery() {
      // 判断是否携带报告id
      if (!this.$route.query.repId) {
        this.showError = true;
        return;
      }

      this.reportId = this.$route.query.repId;
      this.showLoading = true;
      // 查询解读状态 0未生成 1生成中 2已生成
      companyRepoAnalyzeGet(this.reportId)
        .then((res) => {
          if (res.status === "0") {
            // 未解读 调用生成接口 并展示进度条 60秒生成时间
            companyRepoAnalyze(this.reportId)
              .then(() => {
                this.hideLoading();
                this.startProgressTimer();
              })
              .catch(() => {
                this.hideLoading(() => {
                  this.showError = true;
                  this.errorMessage = "网络错误，请联系管理员";
                });
              });
          } else if (res.status === "1") {
            this.hideLoading();
            // 解读中 展示解读中提示
            this.startProgressTimer();
          } else if (res.status === "2") {
            console.log("res", res);
            // 已解读 展示解读结果
            this.htmlData = res.body;
            this.hideLoading();
          }
        })
        .catch(() => {
          this.hideLoading(() => {
            this.showError = true;
            this.errorMessage = "网络错误，请联系管理员";
          });
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    hideLoading(callback) {
      this.showLoading = false;
      this.isFadingOutLoading = false;
      if (callback && typeof callback === "function") {
        callback();
      }
    },
    getShareTxt() {
      let icon =
        "https://static.xchengtech.cn/f8cfbf0167444157ad49429ff76201ae.png";
      getWx().then((res) => {
        window.wx.updateAppMessageShareData({
          title: "AI报告解读", // 分享标题
          desc: "盈利健康度、现金流韧性、成本穿透、税务效率等多维度分析", // 分享描述
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: icon, // 分享图标
          success: function (res) {
            console.log("res", res);
            //afterShare();
          },
        });
      });
    },
  },
};
</script>
<style scoped>
.htmlStyle {
  padding-bottom: 20vw;
  max-width: 100vw;
  overflow: scroll;
}

.progress-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(10px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.progress-container.fade-out {
  opacity: 0;
  transform: scale(0.9);
  pointer-events: none;
}

.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9998;
  backdrop-filter: blur(5px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.loading-container.fade-out {
  opacity: 0;
  transform: scale(0.9);
  pointer-events: none;
}

.loading-wrapper {
  background: white;
  border-radius: 24px;
  padding: 8vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4vw;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease-out;
}

.loading-dots {
  display: flex;
  gap: 12px;
  align-items: center;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3776ff 0%, #1b5dd9 100%);
  animation: bounce 1.4s ease-in-out infinite;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0.6);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.loading-text {
  font-size: 16px;
  color: #696971;
  font-weight: 500;
}

.error-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  backdrop-filter: blur(5px);
}

.error-wrapper {
  background: white;
  border-radius: 24px;
  padding: 8vw;
  width: 80vw;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4vw;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease-out;
}

.error-icon {
  margin-bottom: 2vw;
}

.error-message {
  font-size: 16px;
  color: #696971;
  text-align: center;
  line-height: 1.6;
  margin-bottom: 2vw;
}

.error-button {
  width: 100%;
  padding: 3vw 0;
  background: linear-gradient(135deg, #3776ff 0%, #1b5dd9 100%);
  color: white;
  font-size: 16px;
  font-weight: 600;
  border-radius: 50px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(55, 118, 255, 0.3);
}

.error-button:active {
  transform: scale(0.95);
  box-shadow: 0 2px 8px rgba(55, 118, 255, 0.2);
}

.progress-wrapper {
  background: white;
  border-radius: 24px;
  padding: 8vw;
  width: 80vw;
  max-width: 400px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.progress-circle {
  position: relative;
  width: 200px;
  height: 200px;
  margin: 0 auto 4vw;
}

.progress-svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.progress-bar {
  transition: stroke-dashoffset 0.3s ease;
}

.progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.progress-percentage {
  font-size: 32px;
  font-weight: 700;
  color: #3776ff;
  margin-bottom: 4px;
}

.progress-message {
  text-align: center;
  padding: 4vw 0;
}

.message-icon {
  font-size: 32px;
  margin-bottom: 2vw;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.message-text {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  line-height: 1.6;
}

.reportInterpre-foot {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 4vw;
  gap: 4vw;
  background-color: white;
}

.reportInterpre-foot span {
  display: block;
  border-radius: 6px;
  text-align: center;
  font-weight: 600;
  color: white;
  padding: 4vw;
}

.reportInterpre-foot span:nth-of-type(1) {
  background-color: #3498db;
}

.reportInterpre-foot span:nth-of-type(2) {
  background-color: #e57e23;
}

.reportInterpre-foot .btn-disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/view/reportCommon/reportInterpre.vue